import { post } from "../../../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;
const facilitiesURL = url + "/LeasingFacilities";

const computeFacilityNextStatesList = (documentId, siteId) =>
  post(`${facilitiesURL}/${documentId}/${siteId}/states/compute`, { documentId, siteId });
const updateFacilityState = (documentId, siteId, stateId) =>
  post(`${facilitiesURL}/${documentId}/${siteId}/state`, { documentId, siteId, stateId });

const exp = {
  computeFacilityNextStatesList,
  updateFacilityState
};
export default exp;
